<template>
  <div :class="{ 'rightone': index==0 }" class="goodslist swiper-slide" :style="{width:itemwidth,'margin-right':itemright}">
    <template v-if="goodsmore==''" >
      <div class="goodsimg" @click="gotogoodsinfo(goods.id)">
          <img :src="goods.pic">
      </div>
      <div class="goodsinfo" >
          <p class="goodsname" @click="gotogoodsinfo(goods.id)">
               {{goods.name}}
          </p>
          <ul @click="gotogoodsinfo(goods.id)">
              <li v-for="(param,paramindex) in goods.parameter" :key="paramindex">
                  <p class="xinghao">{{paramindex}}：{{param}}</p>
              </li>              
          </ul>
          <div class="pricesc">
              <span @click="gotogoodsinfo(goods.id)">参考价：￥{{goods.price}}</span>
              <i  @click="editgoods(goods.id)" :class="goods.store==1?iconon:iconoff"></i> 
          </div>
      </div>
    </template>
    <template v-else>        
        <img class="goodslistimg" :src="goodsmore" @click="goto()">          
    </template>
  </div>
</template>


<script>
export default {

    props: {
        index:{
            type: Number,
            default: 0
        },
        goods:{
            type: Object,
            default:() => ({})
        },
        iconoff:{
            type: String,
            default: ""
        },
        iconon:{
            type: String,
            default: ""
        },
        goodsmore:{
            type: String,
            default: ""
        },
        index1:{
            type:Number,
            default: 0
        },
        index2:{
            type:Number,
            default: 0
        },
        urlname:{
            type:String,
            default:""
        },
        params:{
            type:Object,
            default:() => ({})
        },
        itemwidth:{
            type:String,
            default: "213px"
        },
        itemright:{
            type:String,
            default: "29px"
        }

    },
    methods:{
        editgoods(goodsid){
            this.$emit('editgoods',goodsid,this.index,this.index1,this.index2);
        },
        goto(){
            if(this.urlname=="goodslist"){
                var pid = this.params.pid==0?this.params.id:this.params.pid;
                var classid = this.params.pid==0?0:this.params.id;
                var classname = this.params.pid==0?this.params.name:this.params.pname;
                this.$router.push({name:this.urlname,params:{pid:pid,classid:classid,classname:classname}})
            }else{
                this.$router.push({name:this.urlname,params:{id:1}})
            }            
        },
        gotogoodsinfo(goodsid){
            this.$router.push({name:"goodsinfo",params:{goodsid:goodsid}})
        }   
    }
}
</script>

<style scoped>
    .goodslist{
        width: 213px;
        overflow: hidden;
        float: left;
        margin-right: 29px;
        margin-top: 33px;
        border-radius: 5px;
        height: 330px;
        cursor:pointer;
        background-color: #fff;
    }
    .goodslist:hover{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .rightone{
        margin-right:0;
    }
    /* .rightone:hover{
        box-shadow: none;
    } */
    .goodsimg{
        width: 213px;
        overflow: hidden;

    }
    .goodsimg img{
        width: 181px;
        height: 180px;

    }
    .goodsinfo{
        width: 180px;
        overflow: hidden;
        padding: 10px;
        text-align: left;
    }
    .goodsinfo .goodsname{
        font-size: 15px;
        height:20px;
        color: #303030;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .pricesc{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .goodsinfo li{
        font-size: 12px;
        margin-top:2px;
        color: #555555;
        line-height: 1.6;
    }
    .goodsinfo .xinghao{
        overflow:hidden;

        white-space: nowrap;

        text-overflow: ellipsis;

        -o-text-overflow:ellipsis;
    }
    .goodsinfo span{
        font-size: 14px;
        color: #FF0000;
    }
    .goodsinfo i{
        color: #FBB113;
        float: right;
    }
    .goodsinfo ul{
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .icon-shoucang1:before{
        font-size: 23px;
    }
    .el-icon-star-off:before{
        font-size: 25px;
    }
    .goodslistimg{
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/IndustryGoodsItem.vue